import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const LanguageContext = createContext({ lang: "es", setLang: () => {}, t: (obj) => obj });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "es";
    return window.localStorage.getItem("sacrvm.lang") || "es";
  });

  useEffect(() => {
    window.localStorage.setItem("sacrvm.lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const t = useMemo(
    () => (obj) => {
      if (obj == null) return "";
      if (typeof obj === "string") return obj;
      if (typeof obj === "object" && (obj.es !== undefined || obj.en !== undefined)) {
        return obj[lang] ?? obj.es ?? obj.en ?? "";
      }
      return obj;
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  return useContext(LanguageContext);
}
